import React from 'react';
import createSvgIcon from '../../../utils/createSvgIcon';

export default createSvgIcon(
  [<g key="0"><path fill="currentColor" fillRule="evenodd" d="M20 4.002V1h-2v3.002h-3c.01.01 0 2.0015 0 2.0015h3v2.992c.01.01 2 0 2 0v-2.992h3V4.002zM11 4a9.02 9.02 0 0 1 2 .2233v1.8594A7.18 7.18 0 0 0 11 5.8c-3.969 0-7.2 3.231-7.2 7.2s3.231 7.2 7.2 7.2 7.2-3.231 7.2-7.2a7.18 7.18 0 0 0-.2827-2h1.8594A9.02 9.02 0 0 1 20 13c0 4.968-4.032 9-9 9s-9-4.032-9-9 4.032-9 9-9M9.2 17.05 14.6 13 9.2 8.95z" clipRule="evenodd" /></g>,<defs key="1"></defs>,]
, 'CameraVideoAddVideoOutlinedx');
